import React, { useState } from "react";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import axios from "../../axios";
import urls from "../../Utils/urls";
import PopupWrapper from "../../components/PopupWrapper";
import DragAndDrop from "../../components/Tools/Helper-Components/DragAndDrop";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import axiosInstance from "axios";
import { selected_authentication_server } from "../../deployment-config";
import { useAbortController } from "../../hooks/useAbortController";
import { useSelector } from "react-redux";

const Attachment = ({
  allAttachments,
  incidentId,
  setRefreshData,
  incident_number,
  isClosedTicket = false
}) => {
  const [imageDataUrls, setImageDataUrls] = useState(
    allAttachments ? new Array(allAttachments?.length).fill(null) : []
  );
  const [file, setFile] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);
  const { signal } = useAbortController();

  const handleDownloadClick = async (name, docType, extension, fileUrl) => {
    if (isDemoAccount) return;
    const id = toast.loading("Downloading in progress...");
    try {
      // const res = await axios.get(
      //   urls.support.getSingleAttachment(name),
      //   {
      //     responseType: "blob", // Request as a binary blob
      //     headers: {
      //       Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
      //     },
      //   },
      //   { signal }
      // );

      // const blob = new Blob([res.data], { type: `application/${docType}` });
      // const url = window.URL.createObjectURL(blob);

      // Create an anchor element for download
      // const a = document.createElement("a");
      // a.href = fileUrl;
      // // a.download = `${name}.${extension}`;
      // a.download = name;
      // a.style.display = "none";
      // document.body.appendChild(a);

      // // Simulate a click event to trigger the download
      // a.click();

      // // Clean up by revoking the URL to free up resources
      // // window.URL.revokeObjectURL(url);
      // document.body.removeChild(a);

      fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = name; // exact name you want
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        });

      toast.update(id, {
        render: "Document Downloaded Successfully",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
    } catch (error) {
      console.error("Error fetching the document:", error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    }
  };
  const handleAttachmentSubmit = () => {
    // const id = toast.loading("Document upload in progress...");
    // const sanitizedFileName = file[0].name.replace(/ /g, "_");
    // const formData = new FormData();
    // // formData.append("document", file[0], sanitizedFileName);
    // for (let i = 0; i < file.length; i++) {
    //   const sanitizedFileName = file[i].name.replace(/ /g, "_");
    //   formData.append("documents", file[i], sanitizedFileName); // 👈 field name is "documents"
    // }
    // formData.append("incident_number", incident_number);
    // formData.append("created_by", userDetails);

    // axios
    //   .post(urls.support.postUploadAttachments, formData, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   })
    //   .then((response) => {
    //     if (response.status === 200) {
    //       const res = axiosInstance.post(
    //         selected_authentication_server.ticket_attachment.endpoint,
    //         {
    //           incident_name: incident_number,
    //           filename: response.data.filename,
    //           incident_id: incidentId,
    //           mime_type: file[0].type,
    //           comment: "",
    //           created_by: userDetails.email,
    //         },
    //         selected_authentication_server.ticket_attachment.headers
    //       );
    //     }
    //     setRefreshData((prevRefreshData) => !prevRefreshData);
    //     toast.update(id, {
    //       render: "Document Uploaded Successfully",
    //       type: "success",
    //       isLoading: false,
    //       ...commonToast,
    //     });
    //     setShowPopup(false);
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     toast.update(id, {
    //       render: "SOME ERROR OCCURED",
    //       type: "error",
    //       isLoading: false,
    //       ...commonToast,
    //     });
    //   })
    //   .finally(() => {
    //     setFile([]);
    //     setTimeout(() => {
    //       toast.dismiss();
    //     }, 3000);
    //   });

    const id = toast.loading("Uploading documents...");

    const uploadPromises = file?.map((singleFile) => {
      const sanitizedFileName = singleFile.name.replace(/ /g, "_");

      const formData = new FormData();
      formData.append("document", singleFile, sanitizedFileName);
      formData.append("incident_number", incident_number);
      formData.append("created_by", userDetails);

      return axios
        .post(urls.support.postUploadAttachments, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status === 200) {
            return axiosInstance.post(
              selected_authentication_server.ticket_attachment.endpoint,
              {
                incident_name: incident_number,
                filename: response.data.filename,
                incident_id: incidentId,
                mime_type: singleFile.type,
                comment: "",
                created_by: userDetails.email,
              },
              selected_authentication_server.ticket_attachment.headers
            );
          }
        });
    });

    Promise.all(uploadPromises)
      .then(() => {
        setRefreshData((prev) => !prev);
        toast.update(id, {
          render: "Document(s) uploaded successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        setShowPopup(false);
      })
      .catch((err) => {
        console.error(err);
        toast.update(id, {
          render: "Some error occurred during upload",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      })
      .finally(() => {
        setFile([]);
        setTimeout(() => toast.dismiss(), 3000);
      });
  };

  const base64ArrayBuffer = (arrayBuffer) => {
    const binary = new Uint8Array(arrayBuffer);
    let base64 = "";
    for (let i = 0; i < binary?.length; i++) {
      base64 += String.fromCharCode(binary[i]);
    }
    return window.btoa(base64);
  };

  const handleLinkClick = async (name, index, fileUrl) => {
    if (isDemoAccount) return;
    try {
      setIsLoadingImage(true);
      // const res = await axios.get(
      //   urls.support.getSingleAttachment(name),
      //   {
      //     headers: {
      //       Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
      //     },
      //     responseType: "arraybuffer",
      //   },
      //   { signal }
      // );

      // const binaryData = res.data;
      // const dataUrl = `data:image/png;base64,${base64ArrayBuffer(binaryData)}`;

      const newImageDataUrls = [...imageDataUrls];
      newImageDataUrls[index] = fileUrl;
      setImageDataUrls(newImageDataUrls);
      setIsLoadingImage(false);
    } catch (error) {
      console.error("Error fetching the image:", error);
    }
  };

  const downloadImage = (dataUrl, imageName) => {
    if (isDemoAccount) return;
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = imageName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="mb-4 rounded-lg mx-auto px-4">
      <div className="p-4">
        <div className="d-flex justify-content-end">
          {!isClosedTicket && (
            <button
              type="button"
              className="btn btn-primary mb-3 mx-3"
              onClick={() => {
                setShowPopup(true);
              }}
            >
              Add Attachments
            </button>
          )}
          {showPopup && (
            <PopupWrapper
              title={
                <h2 className="p-4 font-weight-bold text-dark">
                  Add Attachments
                </h2>
              }
              Component={
                <div>
                  {" "}
                  <DragAndDrop files={file} setFiles={setFile} />
                  <div className="d-flex justify-content-end mt-5">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary text-white"
                      onClick={handleAttachmentSubmit}
                      disabled={file.length === 0}
                    >
                      Add Attachments
                    </button>
                  </div>
                </div>
              }
              toShow={showPopup}
              closeEventHandler={() => {
                setShowPopup(false);
              }}
            />
          )}
        </div>
        <div>
          <div>
            {allAttachments &&
              allAttachments?.map((object, index) => {
                // const fileType = object.name.split(".").pop().toLowerCase();
                const fileType = object.filename.split(".").pop().toLowerCase();
                // const processedName = object?.name.includes(incident_number)
                //   ? object.name.replace(`${incident_number}/`, "")
                //   : object.name;
                const processedName = object?.filename.includes(incident_number)
                  ? object.filename.replace(`${incident_number}/`, "")
                  : object.filename;
                const fileUrl = object.file_path;

                return (
                  <div key={index} className="p-4 shadow-sm rounded mb-5">
                    <div className="accordion">
                      <div
                        role="button"
                        className={`accordion-button ${
                          openAccordion === index ? "" : "collapsed"
                        }`}
                        data-bs-toggle="collapse"
                        data-bs-target={`#attachment${index}`}
                        style={{
                          display: "inline-block",
                          color: "#438ffe",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (fileType === "pdf") {
                            handleDownloadClick(
                              object.filename,
                              "pdf",
                              "pdf",
                              fileUrl,
                            );
                            return;
                          } else if (
                            fileType === "doc" ||
                            fileType === "docx"
                          ) {
                            handleDownloadClick(
                              object.filename,
                              "msword",
                              "doc",
                              fileUrl,
                            );
                            return;
                          } else if (supportedTypes.includes(fileType)) {
                            handleLinkClick(object.name, index, fileUrl);
                          }
                          setOpenAccordion(
                            openAccordion === index ? null : index,
                          );
                        }}
                      >
                        {/* {object.name} */}
                        {processedName}
                        <i className="bi bi-chevron-down float-end"></i>
                      </div>
                      <div
                        className={`collapse ${
                          openAccordion === index ? "show" : ""
                        }`}
                        id={`attachment${index}`}
                      >
                        {isLoadingImage ? (
                          <SpinnerBlock />
                        ) : (
                          <>
                            {imageDataUrls[index] && (
                              <img
                                style={{ width: "500px" }}
                                src={imageDataUrls[index]}
                              />
                            )}
                            <div>
                              {fileType !== "pdf" && fileType !== "docx" && (
                                <button
                                  className="btn btn-primary mt-2 mx-4"
                                  onClick={() => {
                                    downloadImage(
                                      imageDataUrls[index],
                                      object.name,
                                    );
                                  }}
                                >
                                  Download
                                </button>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Attachment;

const supportedTypes = [
  "msg",
  "jpg",
  "jpeg",
  "png",
  "eml",
  "tiff",
  "xls",
  "xlsx",
  "rtf",
  "txt",
];
